// Mock data for CSV imports
import { CsvImport } from './types';

export const mockCsvImports: CsvImport[] = [
  {
    id: 'import-1',
    type: 'Schools',
    filename: 'schools_import_20250523.csv',
    timestamp: '2025-05-23T03:15:00',
    status: 'success',
    recordsProcessed: 50,
    recordsSucceeded: 50,
    recordsFailed: 0,
    errors: [],
    importedBy: 'system',
    duration: '00:03:45' // 3 minutes 45 seconds
  },
  {
    id: 'import-2',
    type: 'Teachers',
    filename: 'teachers_import_20250523.csv',
    timestamp: '2025-05-23T03:19:00',
    status: 'success',
    recordsProcessed: 1800,
    recordsSucceeded: 1798,
    recordsFailed: 2,
    errors: [
      { row: 145, message: 'Missing required field: email' },
      { row: 967, message: 'Invalid school ID: SCH-9999' }
    ],
    importedBy: 'system',
    duration: '00:05:12' // 5 minutes 12 seconds
  },
  {
    id: 'import-3',
    type: 'Students',
    filename: 'students_import_20250523.csv',
    timestamp: '2025-05-23T03:25:00',
    status: 'success',
    recordsProcessed: 42000,
    recordsSucceeded: 41995,
    recordsFailed: 5,
    errors: [
      { row: 1245, message: 'Missing required field: grade' },
      { row: 5678, message: 'Invalid class ID: CLS-9999' },
      { row: 12456, message: 'Duplicate student ID: ST-7890' },
      { row: 23456, message: 'Invalid school ID: SCH-9999' },
      { row: 34567, message: 'Missing required field: lastName' }
    ],
    importedBy: 'system',
    duration: '00:12:35' // 12 minutes 35 seconds
  },
  {
    id: 'import-4',
    type: 'Standards Map',
    filename: 'standards_map_20250520.csv',
    timestamp: '2025-05-20T10:15:00',
    status: 'success',
    recordsProcessed: 350,
    recordsSucceeded: 350,
    recordsFailed: 0,
    errors: [],
    importedBy: 'user-1', // Super Admin
    duration: '00:01:12' // 1 minute 12 seconds
  },
  {
    id: 'import-5',
    type: 'Questions',
    filename: 'questions_batch_k2_20250522.csv',
    timestamp: '2025-05-22T14:30:00',
    status: 'partial',
    recordsProcessed: 500,
    recordsSucceeded: 485,
    recordsFailed: 15,
    errors: [
      { row: 23, message: 'Invalid standard code: K.ABC.1' },
      { row: 45, message: 'Missing correct answer' },
      { row: 67, message: 'Invalid question type' },
      { row: 89, message: 'Duplicate question ID: Q-1234' },
      { row: 123, message: 'Invalid difficulty level' }
      // More errors truncated for brevity
    ],
    importedBy: 'user-1', // Super Admin
    duration: '00:02:45' // 2 minutes 45 seconds
  }
];
